import { estimationSelector } from "@/redux/selectors/estimation.selector";
import { useSelector } from "@/redux/store";
import type { LineItemXactimateMapping } from "@/interfaces/payloads/xactimate";
import { useMemo } from "react";
import { normalizeLineItemToLowerCase } from "@/components/estimation-details/xactimate/utils/xactimate";

interface XactimateMappingResult {
  cat: string | undefined;
  selCode: string | undefined;
  found: boolean;
}

export const useXactimateMapping = (lineItemId: string, lineItemString: string): XactimateMappingResult => {
  const lineItemXactimateMapping = useSelector(estimationSelector.lineItemXactimateMapping);

  return useMemo(() => {
    if (!lineItemString || !lineItemXactimateMapping) {
      return { cat: undefined, selCode: undefined, found: false };
    }

    const normalizedLineItem = normalizeLineItemToLowerCase(lineItemString);

    const mapping = lineItemXactimateMapping.find(
      (item: LineItemXactimateMapping) =>
        item.lineItemId === lineItemId && normalizeLineItemToLowerCase(item.lineItem) === normalizedLineItem,
    );

    if (!mapping) {
      return { cat: undefined, selCode: undefined, found: false };
    }

    return {
      cat: mapping.cat,
      selCode: mapping.sel,
      found: true,
    };
  }, [lineItemId, lineItemString, lineItemXactimateMapping]);
};
